import React, { useState, useEffect } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../firebaseConfig";

const AdminFeedback = () => {
  const [feedbackData, setFeedbackData] = useState([]);
  const [formsData, setFormsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredFeedback, setFilteredFeedback] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const feedbackQuery = query(
          collection(db, "feedback"),
          orderBy("time", "desc")
        );
        const feedbackSnapshot = await getDocs(feedbackQuery);
        const feedbackList = feedbackSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFeedbackData(feedbackList);
        setFilteredFeedback(feedbackList);

        const formsSnapshot = await getDocs(collection(db, "forms"));
        const formsList = formsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFormsData(formsList);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = feedbackData.filter(
      (item) =>
        item.name.toLowerCase().includes(query) ||
        item.feedback.toLowerCase().includes(query)
    );
    setFilteredFeedback(filtered);
  };

  if (loading) {
    return <p style={{ textAlign: "center", marginTop: "20px", color: "white" }}>Loading...</p>;
  }

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "1200px",
        margin: "auto",
        fontFamily: "'Roboto', sans-serif",
        background: "#09141b",
        color: "white",
        minHeight: "100vh",
        borderRadius: "10px",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#4caf50", marginBottom: "20px" }}>
        Admin Feedback & Forms Dashboard
      </h1>

      {/* Feedback Section */}
      <section>
        <h2 style={{ color: "#4caf50", marginBottom: "10px" }}>User Feedback</h2>
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search by user name or feedback"
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "1em",
          }}
        />
        <div
          style={{
            backgroundColor: "#1c252b",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#4caf50", color: "#fff" }}>
                <th style={{ padding: "10px", textAlign: "left" }}>User</th>
                <th style={{ padding: "10px", textAlign: "left" }}>Feedback</th>
                <th style={{ padding: "10px", textAlign: "left" }}>Time</th>
              </tr>
            </thead>
            <tbody>
              {filteredFeedback.length > 0 ? (
                filteredFeedback.map((item) => (
                  <tr key={item.id} style={{ borderBottom: "1px solid #444" }}>
                    <td
                      style={{
                        padding: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={
                          item.profilePicture ||
                          "https://via.placeholder.com/50"
                        }
                        alt={item.name}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                      <span>{item.name}</span>
                    </td>
                    <td style={{ padding: "10px" }}>{item.feedback}</td>
                    <td style={{ padding: "10px" }}>
                      {new Date(item.time.toDate()).toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      color: "#ccc",
                    }}
                  >
                    No feedback found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* Forms Section */}
      <section style={{ marginTop: "40px" }}>
        <h2 style={{ color: "#4caf50", marginBottom: "10px" }}>Submitted Forms</h2>
        <div
          style={{
            backgroundColor: "#1c252b",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#4caf50", color: "#fff" }}>
                <th style={{ padding: "10px", textAlign: "left" }}>User ID</th>
                <th style={{ padding: "10px", textAlign: "left" }}>Details</th>
                <th style={{ padding: "10px", textAlign: "left" }}>Pictures</th>
              </tr>
            </thead>
            <tbody>
              {formsData.length > 0 ? (
                formsData.map((form) => (
                  <tr key={form.id} style={{ borderBottom: "1px solid #444" }}>
                    <td style={{ padding: "10px" }}>{form.userID || "N/A"}</td>
                    <td style={{ padding: "10px" }}>
                      {Object.entries(form.details || {}).map(([key, value]) => (
                        <div key={key}>
                          <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
                          {value}
                        </div>
                      ))}
                    </td>
                    <td style={{ padding: "10px" }}>
                      {Array.isArray(form.pictures) && form.pictures.length > 0 ? (
                        <div style={{ display: "flex", gap: "10px" }}>
                          {form.pictures.map((pic, index) => (
                            <img
                              key={index}
                              src={pic}
                              alt={`Car Picture ${index + 1}`}
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            />
                          ))}
                        </div>
                      ) : (
                        <p>No pictures provided</p>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      color: "#ccc",
                    }}
                  >
                    No forms found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default AdminFeedback;
